import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["apiName", "screen", "location", "ctaStyles", "returnFirstCTAOnly"];
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { useSelector } from 'react-redux';
import { APP } from '../../constants/tracking/Locations';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { currentSkuIdForProductSelector, upgradeProductSelector } from '../../selectors/ProductsSelectors';
import { purchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const GenericBundleCTAsContainer = props => {
  const {
      apiName,
      screen,
      location,
      ctaStyles,
      returnFirstCTAOnly
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const currencyCode = useSelector(activeCurrencySelector);
  const skuId = useSelector(state => {
    return currentSkuIdForProductSelector(state, {
      apiName
    });
  });
  const upgradeProduct = useSelector(state => {
    return upgradeProductSelector(state, {
      skuIds: [skuId]
    });
  });
  const purchaseMotions = useSelector(state => purchaseMotionsSelector(state, {
    skuId,
    location
  }));
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const productConfigurations = [createProductConfig({
    skuId
  })];
  const upgradeData = {
    app: APP,
    screen: screen,
    upgradeProduct,
    uniqueId: `${screen}-${upgradeProduct}`
  };
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({
      use: 'primary',
      level: 1,
      productConfigurations,
      purchaseMotions: returnFirstCTAOnly ? [purchaseMotions[0]] : purchaseMotions,
      currencyCode,
      queryParamTerm,
      upgradeData,
      style: ctaStyles,
      filterOwnedMarketingProducts: false
    }, rest),
    publicComponentProps: Object.assign({
      use: 'primary',
      productConfigurations,
      purchaseMotions: returnFirstCTAOnly ? [purchaseMotions[0]] : purchaseMotions,
      numPurchaseMotions: 1,
      maxNumPurchaseMotions: 1,
      queryParamTerm,
      style: ctaStyles
    }, rest)
  });
};
export default GenericBundleCTAsContainer;